import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { eventsQueryKeys } from 'features/events';
import { queryClient } from 'providers';

import { TransectionApiServices } from '../api/transection-api.service';

const { invoiceListRefresh } = TransectionApiServices();

export const useInvoiceListRefresh = () => {
    const { message } = App.useApp();

    return useMutation(
        (payload: any) => {
            return invoiceListRefresh(payload);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: (data: any) => {
                const { ResponseMessage, ResponseStatus } = data;
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                if (ResponseStatus == 1) {
                    message.success(ResponseMessage)
                } else {
                    message.error(ResponseMessage);
                }

            },
        },
    );
};

